import $ from 'jquery'

//
// 集成神策分析数据收集Web JS SDK 	业务JS
//

// Web JS SDK 预置事件和预置属性
// https://manual.sensorsdata.cn/sa/latest/tech_sdk_js_preset_properties-34537658.html
var sensors = window['sensorsDataAnalytic201505']; // SDK对象名称，可自定义
sensors.init({
	// server_url: 'https://da.ipmph.com/sa',
	// server_url : 'http://da.ipmph.com:81/sa?project=default', // 数据接收地址，http调试需指定81端口【测试环境】
	server_url : 'https://da.ipmph.com/sa?project=production', // 数据接收地址【生产环境】
	//show_log : false, // 上线时需要将SDK log关闭:Web JS:https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web-7548149.html#id-.WebJSSDKv1.13-事件的触发日志
	heatmap : {
		// 默认配置表示不自动采集元素点击事件和页面停留事件
		// 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
		clickmap : 'not_collect',
		// 是否开启触达图，not_collect 表示关闭，不会自动采集 $WeSbtay 事件，可以设置 'default' 表示开启。
		scroll_notice_map : 'not_collect'
	},
	use_client_time : true, // 默认为 false ，表示不使用客户端时间，使用服务端时间，如果设置为
	// true，表示使用客户端系统时间
	send_type : 'beacon' // 表示使用 beacon 请求方式发数据
});
// sensors.quick('autoTrack');

// 判断激活平台类型
var platformType = "";
function checkPlatformType() { // 获取请求头中的userAgent
	var u = navigator.userAgent; // 是否是android浏览器
	if (/(iPhone|iPad|iPod|iOS)/i.test(u)) {
		platformType = "H5";
	} else if (/(Android)/i.test(u)) {
		platformType = "H5";
	} else {
		platformType = "WEB";
	}
	;
};
checkPlatformType();

// 设置用户属性
function setUserData() {
	sensors.setProfile({
		account_name : $("#MemberUserName").val(), // 用户名
		user_name : $("#MemberRealName").val(), // SSO的真实姓名
		user_phone : $("#MemberMobile").val(), // 手机号
		user_id : $("#MemberUserID").val() // 用户ID
  });
}

// 获取页面隐藏域ISBN和图书名称
// var activation_bookisbn = [$("#ISBN").val()];
// var activation_bookname = [$("#BookName").val()];

// 神策自定义事件的方法 增值服务_点击激活:Addvalue_Clickactivation
function sendSensorsData_Addvalue_Clickactivation () {
	setUserData();
	sensors.track('Addvalue_Clickactivation', {
		"data_platform" : platformType,
		"is_login_in" : true
	});
}

// 神策自定义事件的方法 增值服务_激活结果返回:Addvalue_ActivationResult
function sendSensorsData_Addvalue_ActivationResult(is_success,activation_bookname,activation_bookisbn) {
	setUserData();
	sensors.track('Addvalue_ActivationResult', {
		"data_platform" : platformType,
		"activation_bookisbn" : activation_bookisbn,
		"activation_bookid" : [], //ID无返回
		"activation_bookname" : activation_bookname,
		"is_success" : is_success
  });
}

// 神策自定义事件的方法 增值服务_H5页面点击下载APP:Addvalue_Download
function sendSensorsData_Addvalue_Download(application_type, appType) {
	var buttonName = "在线浏览资源";
	if ('ios' == appType) {
		buttonName = "ios下载";
	} else if ('andr' == appType) {
		buttonName = "android下载";
  }
	setUserData();
	sensors.track('Addvalue_Download', {
		"application_type" : application_type, // 激活资源的所属平台名称
		"button_name" : buttonName
  });
}

// $("a.a-btn").click(function () {
// 	// 获取页面隐藏域资源平台名称
// 	var application_type = $(this).parents(".box.bgf").find(".pname").val();

// 	// 神策自定义事件的方法 增值服务_H5页面点击下载APP:Addvalue_Download
// 	sendSensorsData_Addvalue_Download(application_type);
// });

let config = {
  sendSensorsData_Addvalue_Clickactivation,
  sendSensorsData_Addvalue_ActivationResult,
  sendSensorsData_Addvalue_Download
}
export default config



// WEBPACK FOOTER //
// ./src/config/sensorsinit.js